import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import LoanStepError from 'components/Credit24/LoanApplication/LoanStepError';
import Button from 'components/common/Button';
import PropTypes from 'prop-types';

export const BankScrapingError = ({ bankScrapingResult: { error }, handleRetry }) => (
  <LoanStepError
    title={<FormattedHTMLMessage id="income_verification.failed.title" />}
    text={error || <FormattedMessage id="income_verification.failed.text" />}
    button={(
      <Button
        type="button"
        onClick={handleRetry}
      >
        <FormattedMessage id="income_verification.button.retry" />
      </Button>
    )}
  />
);

BankScrapingError.propTypes = {
  bankScrapingResult: PropTypes.shape({
    error: PropTypes.string,
  }),
  handleRetry: PropTypes.func.isRequired,
};
